
// use path variables later ?
// const RR = new Path2D()
export const shape = {

// xy position, w width, h height, r radius at the corner
 _roundedRect(ctx, x, y, w, h, r) {
    ctx.moveTo(x, y + r);
    ctx.arcTo(x, y + h, x + r, y + h, r);
    ctx.arcTo(x + w, y + h, x + w, y + h - r, r);
    ctx.arcTo(x + w, y, x + w - r, y, r);
    ctx.arcTo(x, y, x, y + r, r);
},

// a router symbol
// _router(ctx, x, y, r) {
//     let cx = x-2
//     let cy = y-2
//     ctx.moveTo(cx-r-4,cy)
//     ctx.arc(cx, cy,r+4,Math.PI,-Math.PI/2)
//     ctx.moveTo(cx-r,cy)
//     ctx.arc(cx, cy,r,Math.PI,-Math.PI/2)
//     ctx.moveTo(cx-r+4,cy)
//     ctx.arc(cx, cy,r-4,Math.PI,-Math.PI/2)
// },

// the rectangle for the overlay
rectRect(ctx,x,y,w,h,cLine,cFill) {

    if (cFill) {
        ctx.fillStyle = cFill
        ctx.fillRect(x,y,w,h)
    }
    if (cLine) {
        ctx.strokeStyle = cLine
        ctx.strokeRect(x,y,w,h)
    }
},

circle(ctx, x,y,r, color) {
    ctx.beginPath()
    ctx.strokeStyle=color
    ctx.moveTo(x,y)
    ctx.arc(x,y,r,0, 2*Math.PI)
    ctx.stroke()
},

bullet(ctx,x,y,R,cFill) {
    ctx.beginPath()
    ctx.arc(x,y,R,0,2*Math.PI)
    ctx.fillStyle = cFill
    ctx.fill()
},

diamond(ctx,x,y,w,h,cFill) {
    ctx.beginPath()
    ctx.fillStyle = cFill
    ctx.moveTo(x+w/2,y)
    ctx.lineTo(x+w,y+h/2)
    ctx.lineTo(x+w/2,y+h)
    ctx.lineTo(x,y+h/2)
    ctx.lineTo(x+w/2,y)
    ctx.fill()
},

viewTitle(ctx, x, y, h, titleClr, title) {
    ctx.fillStyle = titleClr
    ctx.fillText(title, x + h * 0.5, y + h * 0.75)
},

// a rectangle with rounded corners
viewRect(ctx, x, y, w, h, r, wLine, cLine, cFill) {

    const pi = Math.PI

    ctx.beginPath();
    ctx.lineWidth = wLine
    ctx.moveTo(x, y+r);
    ctx.arc(x+r, y+r,r,pi,-pi/2)
    ctx.lineTo(x+w-r, y)
    ctx.arc(x+w-r,y+r,r,-pi/2,0)
    ctx.lineTo(x+w, y+h-r)
    ctx.arc(x+w-r, y+h-r,r,0,pi/2)
    ctx.lineTo(x+r, y+h)
    ctx.arc(x+r,y+h-r,r,pi/2,pi)
    ctx.lineTo(x,y+r)

    // make a resize symbol in the bottom right corner
    ctx.moveTo(x+w, y+h-r)
    ctx.lineTo(x+w-r, y+h)

    if (cFill) {
        ctx.fillStyle = cFill
        ctx.fill()
    }
    if (cLine) {
        ctx.strokeStyle = cLine
        ctx.stroke()
    }
},

// a rectangle with rounded corners
roundedRect(ctx, x, y, w, h, r, wLine, cLine, cFill) {

    const pi = Math.PI

    ctx.beginPath();
    ctx.lineWidth = wLine
    ctx.moveTo(x, y+r);
    ctx.arc(x+r, y+r,r,pi,-pi/2)
    ctx.lineTo(x+w-r, y)
    ctx.arc(x+w-r,y+r,r,-pi/2,0)
    ctx.lineTo(x+w, y+h-r)
    ctx.arc(x+w-r, y+h-r,r,0,pi/2)
    ctx.lineTo(x+r, y+h)
    ctx.arc(x+r,y+h-r,r,pi/2,pi)
    ctx.lineTo(x,y+r)
    if (cFill) {
        ctx.fillStyle = cFill
        ctx.fill()
    }
    if (cLine) {
        ctx.strokeStyle = cLine
        ctx.stroke()
    }
},

roundedHeader(ctx, x, y, w, h, r, wLine, cLine, cFill) {

    const pi = Math.PI

    ctx.beginPath();
    ctx.lineWidth = wLine
    ctx.moveTo(x, y+r);
    ctx.arc(x+r, y+r,r,pi,-pi/2)
    ctx.lineTo(x+w-r, y)
    ctx.arc(x+w-r,y+r,r,-pi/2,0)
    ctx.lineTo(x+w, y+h)
    ctx.lineTo(x, y+h)
    ctx.lineTo(x,y+r)
    if (cFill) {
        ctx.fillStyle = cFill
        ctx.fill()
    }
    if (cLine) {
        ctx.strokeStyle = cLine
        ctx.stroke()
    }
},

grid(ctx, x, y, w, h, dx, dy, cLine, cAxis) {

    ctx.beginPath()

    ctx.lineWidth = 1
    ctx.strokeStyle = cLine

    const maxy = y + h
    for (let sy = y-y%dy; sy < maxy; sy += dy) {
        ctx.moveTo(x, sy)
        ctx.lineTo(x+w, sy)
    }
    const maxx = x + w
    for (let sx = x-x%dx; sx < maxx; sx += dx) {
        ctx.moveTo(sx, y)
        ctx.lineTo(sx, y+h)
    }
    ctx.stroke()

    // The x and y axis
    ctx.beginPath()
    ctx.strokeStyle = cAxis
    ctx.moveTo(x,0)
    ctx.lineTo(x+w, 0)
    ctx.moveTo(0, y)
    ctx.lineTo(0, y+h)
    ctx.stroke()
},



textWidth(ctx,text) {
    return ctx.measureText(text).width
},

// Fit a string to a given pixel width using the current ctx.font.
// Returns the possibly truncated string, optionally ending with an ellipsis.
fitText(ctx, text, maxWidth) {

    // Early accept
    const fullWidth = ctx.measureText(text).width;
    if (fullWidth <= maxWidth) return text;

    const ellipsis = '…';
    const ellW = ctx.measureText(ellipsis).width;

    // Binary search for the largest prefix that fits (including ellipsis width)
    let low = 0, high = text.length;
    let best = 0;
    while (low < high) {
        const mid = Math.floor((low + high + 1) / 2);
        const substr = text.slice(0, mid);
        const w = ctx.measureText(substr).width + ellW;
        if (w <= maxWidth) {
            best = mid;
            low = mid;
        } else {
            high = mid - 1;
        }
    }

    const clipped = text.slice(0, best);
    return clipped + ellipsis;
},

labelText(ctx, text, font, cText,x,y,w,h) {

    // change the font
    const saveFont = ctx.font
    ctx.font = font

    ctx.fillStyle = cText
    ctx.fillText(text,x,y + 0.5*h)

    // set the font back
    ctx.font = saveFont
},

labelCursor(ctx,text,x,y,w,h,pCursor) {
    let cx = ctx.measureText(text.slice(0,pCursor)).width
    return {x: x + cx + 1, y: y-0.25*h}
},

pinIcons(ctx, text, cText,x,y,w,h) {

    const saveFont = ctx.font
    ctx.font= "normal 8px tahoma"
    ctx.fillStyle = cText
    ctx.fillText(text,x,y + 0.5*h)
    ctx.font = saveFont
},

leftText(ctx, text, cText,x,y,w,h) {
    ctx.fillStyle = cText
    ctx.fillText(text,x,y + 0.75*h)
},

rightText(ctx, text,cText,x,y,w,h) {
    ctx.fillStyle = cText
    let tw = ctx.measureText(text).width
    ctx.fillText(text, x + w - tw, y+0.75*h)
},

centerText(ctx, text,font, cText,x,y,w,h) {

    const saveFont = ctx.font
    ctx.font = font
    ctx.fillStyle = cText
    let tm = ctx.measureText(text)
    ctx.fillText(text, x + (w - tm.width)/2, y+0.75*h)
    ctx.font = saveFont
},

centerLineText(ctx, text,cText,cLine,x,y,w,h) {

    ctx.beginPath()
    ctx.fillStyle = cText
    ctx.strokeStyle = cLine
    const tm = ctx.measureText(text)
    const guard = 5

    ctx.moveTo(x,y+h/2)
    ctx.lineTo(x + (w - tm.width)/2 - guard, y+h/2)
    ctx.moveTo(x + (w + tm.width)/2 + guard, y+h/2)
    ctx.lineTo(x+w,y+h/2)
    ctx.stroke()

    ctx.fillText(text, x + (w - tm.width)/2, y+0.75*h)
},

// interface text
ifName(ctx, text,color,rc) {

    const {x,y,w,h} = rc
    
    ctx.beginPath()

    ctx.strokeStyle = color.line
    ctx.fillStyle = color.line
    ctx.lineWidth=1

    const tm = ctx.measureText(text)
    const guard = 5

    const left = x + (w - tm.width)/2
    const cy = y+h/2

    ctx.moveTo(x,cy)
    ctx.lineTo(left - guard, cy)
    ctx.moveTo(left + tm.width + guard, cy)
    ctx.lineTo(x+w,cy)

    //ctx.strokeRect(left-guard,y,tm.width+10,h)

    ctx.stroke()

    ctx.fillStyle = color.text
    ctx.fillText(text, left, y+0.75*h)
},


cursorIndex(ctx, text, xStart, xWhere) {

    const width = ctx.measureText(text).width

    if (xWhere < xStart) return 0
    if (xWhere > xStart + width) return text.length

    let xHere = xStart
    for (let i = 0; i < text.length ; i++) {
        if (xHere >= xWhere)  return i
        xHere += ctx.measureText(text[i]).width
    }
    return text.length
},

// draw a cursor
cursorDraw(ctx,x,y,w,h,cCursor) {
    ctx.fillStyle = cCursor
    ctx.fillRect(x,y,w,h)
},

// to draw pads
bulletRect(ctx,x,y,w,h,cRect, rBullet) {

    ctx.beginPath()
    ctx.fillStyle = cRect
    ctx.fillRect(x + rBullet, y, w, h)
    ctx.arc(x + rBullet,y+h/2,rBullet,Math.PI/2,-Math.PI/2)
    //ctx.arc(x + rBullet,y+h/2,rBullet,0,2*Math.PI)
    ctx.fill()
},

rectBullet(ctx,x,y,w,h, cRect, rBullet) {

    ctx.beginPath()
    ctx.fillStyle = cRect
    ctx.fillRect(x, y, w - rBullet, h)
    ctx.arc(x + w - rBullet,y+h/2,rBullet,-Math.PI/2,Math.PI/2)
    //ctx.arc(x + w - rBullet,y+h/2,rBullet,0,2*Math.PI)
    ctx.fill()
},

corner(ctx,top,left, x,y,w,h, cFill) {

    ctx.beginPath()
    ctx.fillStyle = cFill
    if (left){
        ctx.moveTo(x, y)
        ctx.lineTo(x+w,y+h)
        ctx.arc(x+w/2, y+h/2,w/2,Math.PI/2,Math.PI)
        ctx.lineTo(x,y)
    }
    else {
        ctx.moveTo(x, y+h)
        ctx.lineTo(x+w,y)
        ctx.arc(x+w/2, y+h/2,w/2,0,Math.PI/2)
        ctx.lineTo(x,y+h)
    }
    ctx.fill()
},

leftTriangle(ctx, x,y,w,h,cFill) {
    ctx.beginPath()
    ctx.fillStyle = cFill
    ctx.moveTo(x,y+h/2)
    ctx.lineTo(x+w,y+h)
    ctx.lineTo(x+w,y)
    ctx.lineTo(x,y+h/2)
    ctx.fill()
},

rightTriangle(ctx, x,y,w,h,cFill) {
    ctx.beginPath()
    ctx.fillStyle = cFill
    ctx.moveTo(x,y)
    ctx.lineTo(x,y+h)
    ctx.lineTo(x+w,y+h/2)
    ctx.lineTo(x,y)
    ctx.fill()
},

triangleBall(ctx, x,y,w,h,cFill) {

    const r = 3
    const h2 = h/2

    ctx.beginPath()
    ctx.fillStyle = cFill
    ctx.moveTo(x,y+h2)
    ctx.lineTo(x+w,y+h)
    ctx.lineTo(x+w,y)
    ctx.lineTo(x,y+h2)

    ctx.arc(x+w+r,y+h2,r,0,2*Math.PI)

    ctx.fill()
},

ballTriangle(ctx, x,y,w,h,cFill) {

    const r = 3
    const h2 = h/2

    ctx.beginPath()
    ctx.fillStyle = cFill
    ctx.moveTo(x,y)
    ctx.lineTo(x,y+h)
    ctx.lineTo(x+w,y+h2)
    ctx.lineTo(x,y)

    ctx.arc(x-r,y+h2,r,0,2*Math.PI)

    ctx.fill()
},

triangle(ctx, x,y,w,h,type,cFill) {

    ctx.beginPath()
    ctx.fillStyle = cFill
    switch (type) {

    case "up":
        ctx.moveTo(x, y+h)
        ctx.lineTo(x+w,y+h)
        ctx.lineTo(x+w/2,y)
        ctx.lineTo(x,y+h)
        break

    case "down" :
        ctx.moveTo(x,y)
        ctx.lineTo(x+w/2,y+h)
        ctx.lineTo(x+w,y)
        ctx.lineTo(x,y)
        break

    case "left" :
        ctx.moveTo(x,y+h/2)
        ctx.lineTo(x+w,y+h)
        ctx.lineTo(x+w,y)
        ctx.lineTo(x,y+h/2)
        break

    case "right" :
        ctx.moveTo(x,y)
        ctx.lineTo(x,y+h)
        ctx.lineTo(x+w,y+h/2)
        ctx.lineTo(x,y)
        break
    }
    ctx.fill()
},

tack(ctx, x,y,w,h,zone,inflow,selective,cFill) {

    // inflow changes the direction of the arrow
    if (inflow) zone = zone == 'E' ? 'W' : zone == 'W' ? 'E' : zone == 'N' ? 'S' : 'N';

    const color = selective ? "#000000" : cFill

    ctx.beginPath()
    ctx.fillStyle = color

    switch (zone) {

    case "N":
        ctx.moveTo(x, y+h)
        ctx.lineTo(x+w,y+h)
        ctx.lineTo(x+w/2,y)
        ctx.lineTo(x,y+h)
        break

    case "S" :
        ctx.moveTo(x,y)
        ctx.lineTo(x+w/2,y+h)
        ctx.lineTo(x+w,y)
        ctx.lineTo(x,y)
        break

    case "W" :
        ctx.moveTo(x,y+h/2)
        ctx.lineTo(x+w,y+h)
        ctx.lineTo(x+w,y)
        ctx.lineTo(x,y+h/2)
        break

    case "E" :
        ctx.moveTo(x,y)
        ctx.lineTo(x,y+h)
        ctx.lineTo(x+w,y+h/2)
        ctx.lineTo(x,y)
        break
    }
    ctx.fill()

    if (! selective) return

    ctx.strokeStyle = cFill
    ctx.lineWidth = 1

    switch (zone) {

    case "N":
        ctx.moveTo(x, y+h)
        ctx.lineTo(x+w,y+h)
        ctx.lineTo(x+w/2,y)
        ctx.lineTo(x,y+h)
        break

    case "S" :
        ctx.moveTo(x,y)
        ctx.lineTo(x+w/2,y+h)
        ctx.lineTo(x+w,y)
        ctx.lineTo(x,y)
        break

    case "W" :
        ctx.moveTo(x,y+h/2)
        ctx.lineTo(x+w,y+h)
        ctx.lineTo(x+w,y)
        ctx.lineTo(x,y+h/2)
        break

    case "E" :
        ctx.moveTo(x,y)
        ctx.lineTo(x,y+h)
        ctx.lineTo(x+w,y+h/2)
        ctx.lineTo(x,y)
        break
    }
    ctx.stroke()
},

bridge(ctx, x, y, r, color) {            

    ctx.beginPath()

    ctx.fillStyle = '#000000'
    ctx.strokeStyle = color
    ctx.lineWidth = 2
    ctx.rect(x - r, y - r, 2 * r, 2 * r)
    ctx.stroke()
    ctx.fill()
},

// draws three arches
wirelessSymbol(ctx, x, y,r,color) {

    // router symbol
    ctx.beginPath()
    ctx.strokeStyle = color
    //shape._router(ctx,x,y,r)

    let cx = x-2
    let cy = y-2
    ctx.moveTo(cx-r-4,cy)
    ctx.arc(cx, cy,r+4,Math.PI,-Math.PI/2)
    ctx.moveTo(cx-r,cy)
    ctx.arc(cx, cy,r,Math.PI,-Math.PI/2)
    ctx.moveTo(cx-r+4,cy)
    ctx.arc(cx, cy,r-4,Math.PI,-Math.PI/2)

    ctx.stroke()
},

xemptyLabel(ctx, x,y,r, color) {

    ctx.beginPath()
    ctx.fillStyle = color
    ctx.fillRect(x-r,y-r,2*r,2*r)
},

emptyLabel(ctx, x,y,r, color) {

    ctx.beginPath()
    ctx.fillStyle = color
    ctx.arc(x,y,r,0,2*Math.PI)
    ctx.fill()

    // inner radius
    const ir = r - 2.5
    ctx.beginPath()
    ctx.lineWidth = ir
    ctx.strokeStyle = '#000000'
    ctx.arc(x,y,ir,0,2*Math.PI)
    ctx.stroke()
},

drawWire(ctx, color, width, points) {

    // check
    let l = points.length
    if (l < 2) return

    ctx.beginPath()

    ctx.lineWidth = width
    ctx.strokeStyle = color

    const arcRadius = 7.5
    const arcSpace = 15

    // ..move to the first point
    ctx.moveTo(points[0].x, points[0].y)

    // draw the segments ..
    for (let i=0; i < l-1; i++) {

        const a = points[i]
        const b = points[i+1]

        // ..if there is enough space..
        if (( Math.abs(a.y - b.y)  >= arcSpace ) || (  Math.abs(a.x - b.x)  >= arcSpace )) 

            // ..draw a line with an arc..
            ctx.arcTo(a.x, a.y, b.x, b.y, arcRadius)
        
        else {
            // ..otherwise draw a right angle
            ctx.lineTo(a.x, a.y)
            ctx.lineTo(b.x, b.y)
        }
    }

    // ..but the last segment is straight.
    ctx.lineTo(points[l-1].x, points[l-1].y)
    ctx.stroke()
},

// get the rectangle of the alias - x, y are the position of the tack
// and dir tells where to put the alias wrt the tack
rcAlias(ctx, text, zone, x, y, font) {

    // change the font
    const saveFont = ctx.font
    ctx.font = font

    // The length of the text
    const w = ctx.measureText(text).width

    // shift away from the tack
    const d = {x:20, y:20}

    // small shift to center on wire
    const m = {x:5, y:2.5}

    switch(zone) {

        case 'N': 
            x -= w/2 - m.x
            y -= d.y
            break;

        case 'S':
            x -= w/2 - m.x
            y += d.y
            break;

        case 'E':
            x += d.x
            y -= m.y
            break;

        case 'W':
            x -= w + d.x
            y -= m.y
            break;   
    }

    ctx.font = saveFont

    return {x,y,w,h:14}
},

// Draw the alias 
drawAlias(ctx,text,rc,cRect,font) {

    // change the font
    const saveFont = ctx.font
    ctx.font = font

    // extra white space before and after the text
    const ws = 5

    ctx.beginPath();
    ctx.fillStyle = cRect
    shape._roundedRect(ctx, rc.x - ws,rc.y,rc.w + 2*ws,rc.h, 5)
    ctx.fill()

    // text
    ctx.fillStyle = '#000000'
    ctx.fillText(text,rc.x,rc.y + 0.75*rc.h)  

    // set the font back
    ctx.font = saveFont
},

}
